
export default class GetUserSalaryAggregatesRequest {
    public month: Date = new Date();

    public mounterUserIds: string[] = [];

    /** Return only items where mounter has any of the given cost pools. */
    public mounterCostPoolIds: string[] = [];
}